import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import "./ConfirmationStep.css";

const ConfirmationStep = ({ formik, selectedPack }) => {
    const { t } = useTranslation();
    const { handleSubmit } = formik;
    const packFrequencyMap = new Map([
        ["daily", 86],
        ["weekly", 88],
        ["one_day", 86],
        ["one_week", 88]
    ]);

    function getPrice(pack) {
        if (!pack) {
            return;
        }

        const amount = pack.pack_price;
        const frequency = pack.is_one_time ? "" : t(packFrequencyMap.get(pack.pack_frequency))?.toLowerCase();

        return pack.is_one_time ? `${amount} U` : `${amount} U/${frequency}`;
    }

    useEffect(() => {
        setTimeout(() => {
            handleSubmit();
        }, [3000]);
    }, [handleSubmit]);

    return (
        <>
            <div className="login-thumbnail2">
                <img src="/image/confirmation.svg" alt="login" />
            </div>

            <Form className="confirmation">
                {selectedPack && (<>
                    <h3 className="title my-3 text-center">{t('89')}!</h3>
                    <p className="mx-auto my-0 text-center">
                        {formik.values.offerType === "Subscription" ? t('90') : t('96')}.
                    </p>
                    <p className="mx-auto my-0 text-center">
                        {t('95')}: {getPrice(selectedPack)}
                    </p>
                </>)}
                <p className="mx-auto my-3 text-center">
                    {t('91')}
                </p>
            </Form>
        </>
    )
}

export default ConfirmationStep;
